import React, { Component } from "react"
import EditButtonSectionModal from "../../editbutton.component.jsx"
import { FormattedDate, FormattedMessage, injectIntl, defineMessages, FormattedNumber } from "react-intl"
import SectionWrapper from "../../sectionwrapper.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import InvoiceStatusBadge from "../../../../invoice/status.component.jsx"
import EventBus from "../../../../common/EventBus.js"
import {
    AccountTransactionTypeInvoice,
    AccountTransactionTypeCreditMemo
} from "../../../../state/contact/AccountTransactionsType"

const messages = defineMessages({
    dueDate: {
        id: "proposal.customer_account_statement.due_date",
        defaultMessage: "Due date"
    },
    fullyPaidAt: {
        id: "proposal.customer_account_statement.fully_paid_date",
        defaultMessage: "Fully paid date"
    },
    createdAt: {
        id: "proposal.customer_account_statement.created_date",
        defaultMessage: "Created date"
    },
    sentAt: {
        id: "proposal.customer_account_statement.sent_date",
        defaultMessage: "Sent date"
    },
    uniqueExternalId: {
        id: "proposal.customer_account_statement.external_id",
        defaultMessage: "External ID"
    },
    lightspeedWorkorderId: {
        id: "proposal.customer_account_statement.workorder_id",
        defaultMessage: "Workorder ID"
    },
    capturedAt: {
        id: "templates.sections.form.edit.content.customer_account_statement.captured_date",
        defaultMessage: "Credit Memo Captured date"
    }
})

class CustomerAccountStatementContentSection extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || "",
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function() {},
            id: this.props.id || "",
            isPdf: this.props.idPdf || false
        }
        this.showEdition = this.showEdition.bind(this)
        this.hideEdition = this.hideEdition.bind(this)
        this.handleProposalRefresh = this.handleProposalRefresh.bind(this)
        this.sortFunctionByDate = this.sortFunctionByDate.bind(this)
        this.isExpectedCustomFieldTypeOrEmpty = this.isExpectedCustomFieldTypeOrEmpty.bind(this)
        EventBus.listen(EventBus.TopicProposalRefresh, "customer-account-statement-section", this.handleProposalRefresh)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || "",
            isPdf: nextProps.isPdf || false
        })
    }

    showEdition() {
        if (this.state.editable) {
            this.setState({
                edition: true
            })
        }
    }

    hideEdition() {
        if (this.state.editable) {
            this.setState({
                edition: false
            })
        }
    }

    sortFunctionByDate(a, b, sortAttribute) {
        return new Date(a[sortAttribute] - new Date(b[sortAttribute]))
    }

    handleProposalRefresh(event) {
        this.setState({
            variables: event.getData().variables
        })
    }

    isExpectedCustomFieldTypeOrEmpty(customFieldType, expectedCustomFieldType) {
        if (!customFieldType) {
            return true
        }
        return customFieldType === expectedCustomFieldType
    }

    renderCustomFieldValues(customFields, type, t) {
        return customFields
            .filter(cf => this.isExpectedCustomFieldTypeOrEmpty(cf.customFieldType, type))
            .map(field => {
                let value = t[field.customFieldId]
                const customField = t.customFieldValues
                    ? t.customFieldValues.find(f => f.definitionId === field.customFieldId)
                    : ""
                if (customField) {
                    value = customField.value
                    if (customField.fieldType === "date") {
                        return value ? (
                            <td>
                                <FormattedDate year="numeric" month="long" day="numeric" value={value} />
                            </td>
                        ) : (
                            <td>{"-"}</td>
                        )
                    } else {
                        return value ? (
                            <td>
                                <span>{value}</span>
                            </td>
                        ) : (
                            <td>{"-"}</td>
                        )
                    }
                }

                if (field.customFieldId === "uniqueExternalId") {
                    value = value && value.length > 0 ? value[0].split("_")[1] : ""
                    return value ? (
                        <td>
                            <span>{value}</span>
                        </td>
                    ) : (
                        <td>{"-"}</td>
                    )
                } else if (field.customFieldId === "poNumber") {
                    return <td>{t[field.customFieldId] || "-"}</td>
                }
                return t[field.customFieldId] ? (
                    <td>
                        <FormattedDate year="numeric" month="long" day="numeric" value={value} />
                    </td>
                ) : (
                    <td>{"-"}</td>
                )
            })
    }

    render() {
        if (!this.state.section || !this.state.variables.customer.customerAccount) {
            return <div />
        }
        let invoices = []
        let memos = []
        if (!this.state.section.attributes.content.hideInvoices) {
            invoices = this.state.variables.customer.currentCustomerAccountTransactions.filter(t => t._type === "invoices")
        }
        if (!this.state.section.attributes.content.hideCreditMemos) {
            memos = this.state.variables.customer.currentCustomerAccountTransactions.filter(t => t._type === "credit-memos")
        }
        let extra = null
        if (memos.length === 0 && invoices.length === 0 && this.state.editable) {
            extra = (
                <div className={"w-100 p-3"}>
                    <p className={"section-empty-message text-center"}>
                        <Icon value={"file-invoice"} />
                        <small className={"ml-2"}>
                            <FormattedMessage
                                id="proposal.customer_account_statement.empty_message"
                                defaultMessage="Due invoices and available credit memos are hidden or empty"
                            />
                        </small>
                    </p>
                </div>
            )
        }
        const totalGreaterThanZero =
            this.state.variables.customer &&
            this.state.variables.customer.customerAccount &&
            parseFloat(this.state.variables.customer.customerAccount.attributes.owingBalance) > 0
        let customFields = this.state.section.attributes.content.customFields || []
        customFields = customFields.map(fieldJson => JSON.parse(fieldJson))
        const classNameSupportingPdf = !this.state.isPdf ? "d-none d-md-block" : "d-block"
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                {invoices.length > 0 ? (
                    <table className="table my-3 table-sm">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.invoice_table.invoice_label"
                                        defaultMessage="Invoice"
                                    />
                                </th>
                                {customFields.filter(cf =>
                                    this.isExpectedCustomFieldTypeOrEmpty(cf.customFieldType, AccountTransactionTypeInvoice)
                                ).length === 0 && (
                                    <th scope="col">
                                        <FormattedMessage
                                            id="proposal.customer_account_statement.invoice_table.due_date_label"
                                            defaultMessage="Due date"
                                        />
                                    </th>
                                )}
                                {customFields
                                    .filter(cf =>
                                        this.isExpectedCustomFieldTypeOrEmpty(cf.customFieldType, AccountTransactionTypeInvoice)
                                    )
                                    .map(field => {
                                        return (
                                            <th scope="col">
                                                {messages[field.customFieldId] &&
                                                this.props.intl.formatMessage(messages[field.customFieldId]) ===
                                                    field.customFieldLabel
                                                    ? this.props.intl.formatMessage(messages[field.customFieldId])
                                                    : field.customFieldLabel}
                                            </th>
                                        )
                                    })}
                                <th scope="col" className={classNameSupportingPdf}>
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.invoice_table.amount_label"
                                        defaultMessage="Amount"
                                    />
                                </th>
                                <th scope="col" className={"text-right"}>
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.invoice_table.balance_label"
                                        defaultMessage="Balance"
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices
                                .filter(t => t._type === "invoices")
                                .sort((a, b) => this.sortFunctionByDate(a, b, "sentAt"))
                                .map((t, i) => {
                                    return (
                                        <tr key={i}>
                                            <th scope="row">
                                                <p className={"m-0"}>
                                                    {t.proposalHash ? (
                                                        <a href={"/p/proposals/" + t.proposalHash} target={"_blank"}>
                                                            {t.identifier}
                                                        </a>
                                                    ) : (
                                                        t.identifier
                                                    )}
                                                </p>
                                            </th>
                                            {customFields.filter(cf =>
                                                this.isExpectedCustomFieldTypeOrEmpty(
                                                    cf.customFieldType,
                                                    AccountTransactionTypeInvoice
                                                )
                                            ).length === 0 && (
                                                <td>
                                                    <FormattedDate
                                                        year="numeric"
                                                        month="long"
                                                        day="numeric"
                                                        value={new Date(t.dueDate)}
                                                    />
                                                </td>
                                            )}
                                            {this.renderCustomFieldValues(customFields, AccountTransactionTypeInvoice, t)}
                                            <td className={classNameSupportingPdf}>
                                                <FormattedNumber style="currency" currency={t.currency} value={t.totalAmount} />
                                            </td>
                                            <td className={"text-right pr-2"}>
                                                {parseFloat(t.balance) > 0 ? (
                                                    <FormattedNumber style="currency" currency={t.currency} value={t.balance} />
                                                ) : (
                                                    <InvoiceStatusBadge status={t.status} />
                                                )}
                                            </td>
                                        </tr>
                                    )
                                })}
                            <tr>
                                <td>
                                    <small className={"mr-4"}>
                                        <FormattedMessage
                                            id="proposal.customer_account_statement.last_update_label"
                                            defaultMessage="Last update : {date}"
                                            values={{
                                                date: (
                                                    <FormattedDate
                                                        year="numeric"
                                                        month="long"
                                                        day="numeric"
                                                        value={
                                                            new Date(
                                                                this.state.variables.customer.customerAccount.attributes.updatedAt
                                                            )
                                                        }
                                                    />
                                                )
                                            }}
                                        />
                                    </small>
                                </td>
                                <th className={classNameSupportingPdf}>{""}</th>
                                {customFields.filter(cf =>
                                    this.isExpectedCustomFieldTypeOrEmpty(cf.customFieldType, AccountTransactionTypeInvoice)
                                ).length === 0 && <th>{""}</th>}
                                {customFields
                                    .filter(cf =>
                                        this.isExpectedCustomFieldTypeOrEmpty(cf.customFieldType, AccountTransactionTypeInvoice)
                                    )
                                    .map(field => {
                                        return <th />
                                    })}
                                <th className={"text-right pr-2 " + (totalGreaterThanZero ? "table-dark" : "")}>
                                    {totalGreaterThanZero ? (
                                        <span style={{ fontSize: "1rem" }}>
                                            <strong>
                                                <FormattedNumber
                                                    style="currency"
                                                    currency={
                                                        this.state.variables.customer.customerAccount.attributes
                                                            .owingBalanceCurrency
                                                    }
                                                    value={this.state.variables.customer.customerAccount.attributes.owingBalance}
                                                />
                                            </strong>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                ) : null}

                {memos.length > 0 ? (
                    <table className="table my-3 table-sm">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.credit_memo_table.credit_memo_label"
                                        defaultMessage="Credit memo"
                                    />
                                </th>
                                {customFields
                                    .filter(cf =>
                                        this.isExpectedCustomFieldTypeOrEmpty(
                                            cf.customFieldType,
                                            AccountTransactionTypeCreditMemo
                                        )
                                    )
                                    .map(field => {
                                        return (
                                            <th scope="col">
                                                {messages[field.customFieldId] &&
                                                this.props.intl.formatMessage(messages[field.customFieldId]) ===
                                                    field.customFieldLabel
                                                    ? this.props.intl.formatMessage(messages[field.customFieldId])
                                                    : field.customFieldLabel}
                                            </th>
                                        )
                                    })}
                                {!this.state.section.attributes.content.hideCreditMemosCreatedAt && (
                                    <th scope="col">
                                        <FormattedMessage
                                            id="proposal.customer_account_statement.credit_memo_table.date_label"
                                            defaultMessage="Date"
                                        />
                                    </th>
                                )}
                                <th scope="col" className={classNameSupportingPdf}>
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.credit_memo_table.amount_label"
                                        defaultMessage="Amount"
                                    />
                                </th>
                                <th scope="col" className={"text-right"}>
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.credit_memo_table.remaining_label"
                                        defaultMessage="Remaining"
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {memos
                                .sort((a, b) => this.sortFunctionByDate(a, b, "createdAt"))
                                .map((t, i) => {
                                    return (
                                        <tr key={i}>
                                            <th scope="row">
                                                <p className={"m-0"}>
                                                    {t.identifier}
                                                    <small className={"ml-2"}>{t.notes}</small>
                                                </p>
                                            </th>
                                            {this.renderCustomFieldValues(customFields, AccountTransactionTypeCreditMemo, t)}
                                            {!this.state.section.attributes.content.hideCreditMemosCreatedAt && (
                                                <td>
                                                    <FormattedDate
                                                        year="numeric"
                                                        month="long"
                                                        day="numeric"
                                                        value={new Date(t.createdAt)}
                                                    />
                                                </td>
                                            )}
                                            <td className={classNameSupportingPdf}>
                                                <FormattedNumber style="currency" currency={t.currency} value={t.amount} />
                                            </td>
                                            <td className={"text-right"}>
                                                <FormattedNumber
                                                    style="currency"
                                                    currency={t.currency}
                                                    value={t.remainingAmount}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                            <tr>
                                <td>
                                    <small className={"mr-4"}>
                                        <FormattedMessage
                                            id="proposal.customer_account_statement.last_update_label"
                                            defaultMessage="Last update : {date}"
                                            values={{
                                                date: (
                                                    <FormattedDate
                                                        year="numeric"
                                                        month="long"
                                                        day="numeric"
                                                        value={
                                                            new Date(
                                                                this.state.variables.customer.customerAccount.attributes.updatedAt
                                                            )
                                                        }
                                                    />
                                                )
                                            }}
                                        />
                                    </small>
                                </td>
                                <th className={classNameSupportingPdf} />
                                {customFields
                                    .filter(cf =>
                                        this.isExpectedCustomFieldTypeOrEmpty(
                                            cf.customFieldType,
                                            AccountTransactionTypeCreditMemo
                                        )
                                    )
                                    .map(field => {
                                        return <th />
                                    })}
                                {!this.state.section.attributes.content.hideCreditMemosCreatedAt && <th />}
                                <th className={"text-right pr-2 table-dark"}>
                                    <span style={{ fontSize: "1rem" }}>
                                        <strong>
                                            <FormattedNumber
                                                style="currency"
                                                currency={
                                                    this.state.variables.customer.customerAccount.attributes.creditBalanceCurrency
                                                }
                                                value={this.state.variables.customer.customerAccount.attributes.creditBalance}
                                            />
                                        </strong>
                                    </span>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                ) : null}
                {extra}
            </SectionWrapper>
        )
    }
}

export default injectIntl(CustomerAccountStatementContentSection)



// WEBPACK FOOTER //
// ./src/template/sections/content/customer-account-statement/section.component.jsx